import React, { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import AppRouterPrivate from './AppRouterPrivate'
import AppScaffolding from './AppScaffolding'
import { CallBackFromAuth0 } from './containers/CallBackFromAuth0';
import Landing from './containers/Landing';
import Loading from './components/common/Loading';
import config from './config';
import { useDispatch } from 'react-redux';
import { getUserById } from './components/selector/getUserById';
import allActions from './actions';
import { useSelector } from 'react-redux';
import UserInterfaceTokenGenerator from './containers/Applications/UserInterfaceTokenGenerator';


export const AppRouter = () => {
    
    console.log("Enter into AppRouter.js")

    const dispatch = useDispatch();

    // const { isGettingAuthorizationToken } = useSelector();
    const { user : userSinexiar } = useSelector(state => state.user);

    const {
        // Auth state:
        error,
        isAuthenticated,
        isLoading,
        user,
        // Auth methods:
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
    } = useAuth0();

    useEffect(() => {
        // If userSinexiar doesn't exist, is because is first execution or user refresh the page and lost all user infromatino in Redux and must be reloaded.
        if (userSinexiar.id === null && user) {

            try {
                console.log("AppRouter is loading context data...");
                getAccessTokenSilently().then( (tokenValue) => {
                    // We load token in localStorage in order to let whole application continus working calling old auth.js class.
                    localStorage.setItem('access_token', tokenValue);

                    getIdTokenClaims().then( (token) => {
                        localStorage.setItem('id_token', JSON.stringify(tokenValue));
                    });

                    // Also we load user credential in localStorage for quicker access along all old code.
                    getUserById(user.sub).then( (userSinexiar) => {
                        localStorage.setItem('sessionUser', JSON.stringify(userSinexiar));
                    });

                    // Load information in Redux
                    dispatch(allActions.userActions.loadToken(tokenValue));
                    dispatch(allActions.userActions.getUser(user.sub));
                    dispatch(allActions.roleActions.getRoles());
                    dispatch(allActions.accountActions.getAccounts());
                });
            } catch (error) {
                console.error(error);
                logout();
            }
        } 
    
        // dispatch(allActions.userActions.loadToken(token));
    }, [user])

    // useEffect(() => {       

        
    // }, [token])

    const location = window.location;
    console.log(`isAuthenticated=${isAuthenticated} location: ${location.pathname}`);
    // We controls if user is logged when is redirecting form Auth0 after request a new authorization code for get a Client Application Token.
    if (!isAuthenticated && location.pathname.includes('/application/authorize')) {
        
        return (
                <UserInterfaceTokenGenerator/>
            )

    }

    if (isLoading) {
        return (
            <Loading/>
        )
    }

    if (error) {
        console.log(error);
        debugger
        // return <div>Oops... {error.message}</div>;
    }
 

    if (!isAuthenticated) {
        return loginWithRedirect();
    }

    if (location.pathname === "/logout") {
        logout();
    }
    
    

    if (userSinexiar.id !== null) { // Its means that main information was loaded
        return (
                <Router>
                    <div>
                        <Switch>
                            {/* <AppRouterPublic
                                exact
                                path="/"
                                component={ PublicAppScaffolding }
                                isAuthenticated={ isAuthenticated }
                            /> */}
                            
                            <Route 
                                exact
                                path="/callback" // Callback as redirection form Auth0 login page.
                                component={ CallBackFromAuth0 }
                            />
                            <Route 
                                exact
                                path="/logout" // Logout from application and redirect to Auth0 login page.
                                component={ Landing }
                            />

                            <AppRouterPrivate 
                                isAuthenticated={ isAuthenticated }
                                path="/"
                                component={ AppScaffolding }

                            />

                            {/* <Redirect to="/" /> */}

                        </Switch>
                    </div>
                </Router>
        )
    }

    
    

    return (
        <Loading/>
    )
    
}

export default AppRouter;